module.exports = __webpack_public_path__ + "img/get_coin.3942c594.gif";